import { render, staticRenderFns } from "./DxSelectSupervisorPerformance.vue?vue&type=template&id=4e53c84d&"
import script from "./DxSelectSupervisorPerformance.vue?vue&type=script&lang=js&"
export * from "./DxSelectSupervisorPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports